// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1A34I","image":"Header_image__1Izhq","name":"Header_name__sMIR2","info":"Header_info__2UD3_","infoRow":"Header_infoRow__Pp7cn"};